import { prop } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";

export class ProfessionalCategory extends Resource {
    public override type = 'professionalCategories';
    
    @prop()
    public name!: string;

}